
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import MemoryMatch from "@/components/games/MemoryMatch";
import QuickMath from "@/components/games/QuickMath";
import WordScramble from "@/components/games/WordScramble";

export interface MiniGameConfig {
  id: string;
  name: string;
  title?: string;
  description?: string;
  gameType: string;
  instructions: string;
  difficulty: string;
}

interface MiniGameProps {
  config: MiniGameConfig;
  onClose: () => void;
}

const MiniGame: React.FC<MiniGameProps> = ({ config, onClose }) => {
  const renderGame = () => {
    switch (config.gameType) {
      case "memory":
        return <MemoryMatch />;
      case "math":
        return <QuickMath />;
      case "word":
        return <WordScramble />;
      default:
        return (
          <div className="p-4 text-center">
            <p>Game type not found: {config.gameType}</p>
          </div>
        );
    }
  };

  return (
    <Card className="w-full">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-center">
          <CardTitle>{config.title || config.name}</CardTitle>
          <Button variant="ghost" size="sm" onClick={onClose} className="h-8 w-8 p-0">
            <X className="h-4 w-4" />
          </Button>
        </div>
        <CardDescription>{config.instructions}</CardDescription>
      </CardHeader>
      
      <CardContent>
        {renderGame()}
      </CardContent>

      <CardFooter className="pt-0 flex justify-between">
        <div className="text-xs">
          <span className="bg-primary/10 text-primary px-2 py-1 rounded">
            {config.difficulty}
          </span>
        </div>
        <Button variant="ghost" size="sm" onClick={onClose}>
          Close Game
        </Button>
      </CardFooter>
    </Card>
  );
};

export default MiniGame;
export type { MiniGameProps };
